// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K {
  margin-top: 8px;
}

.\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K:first-child {
  margin-top: 0;
}

.\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K .\\------packages-components-bot-semi-src-components-ui-toast-index-module__icon-Z1vje2, .\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K .\\------packages-components-bot-semi-src-components-ui-toast-index-module__icon-Z1vje2 > span {
  width: 20px;
  height: 20px;
}

.\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K .semi-toast-content {
  border-radius: 8px;
  padding: 12px 16px;
}

.\\------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K .semi-toast-content > .semi-toast-content-text {
  color: var(--light-usage-text-color-text-0, #1d1c23);
  margin-right: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-components-bot-semi-src-components-ui-toast-index-module__container-ct0w4K`,
	"icon": `------packages-components-bot-semi-src-components-ui-toast-index-module__icon-Z1vje2`
};
export default ___CSS_LOADER_EXPORT___;
